'use strict';

import $ from 'jquery';
import './vendor/iframeResizer';

export default function(API) {

	/** Converts numeric degrees to radians */
	if (typeof(Number.prototype.toRad) === 'undefined') {
		Number.prototype.toRad = function() {
			return this * Math.PI / 180;
		}
	}

	/* EOF: for all pages in mobile */

	/* BOF: for all pages */
	function allPages(){

		$('.toggle-columnized-content-block-2').click(function(){
			$(this).parent().parent().parent().parent().find('.columnized-content-block-2').slideToggle(500);
		});

		// Scroll to top linkin näyttäminen ja piilottaminen
		$(window).on('scroll.scrollToTop', function(){
			if( $(window).scrollTop() > $(window).height() ){
				$('#scrollToTop').show();
			} else {
				$('#scrollToTop').hide();
			}
		});

		// Meganav events
		$('body').on('click.meganavlink', '.meganav-wrapper a', function(e){
			e.preventDefault();
			if (window.GoogleTagManager.isEnabled()) {
				window.GoogleTagManager.clickMegaMenuItem( $(this).attr('href') );
			} else {
				window.location = $(this).attr('href');
			}
		});
	}

	/* EOF: for all pages */

	/* BOF: feedback pages */
	function feedbackPage(){

		$('.feedback').on('click', '#feedbackCloseResult', function(){
			$('#searchFaq').val('');
			$('#searchFaqResult').html('');
		});


		var searchTimeout = null;
		var prevSearch = '';
		$('#searchFaq').on('keyup', function(){

			var search = $(this).val();

			if( search.length > 1 && prevSearch !== search ){
				$('#searchFaqResult').html('')
				prevSearch = search;

				$('#searchFaqResult').html('<div class="h4 margin-top-20">Etsitään...</div>')

				clearTimeout(searchTimeout);
				searchTimeout = setTimeout(function(){

					$.ajax({
						url: 'https://intersportoy.zendesk.com/api/v2/help_center/articles/search.json?query=' + search,
						success: renderSearchResult
					})

				}, 1500);
			}
		});
		$('#searchFaqResult').on('click', '.h4', function(e){
			e.preventDefault();
			$('.searchFaqResultItem').addClass('hidden');
			$(this).next().removeClass('hidden');

		});
		function renderSearchResult(data){
			$('#searchFaqResult').html('')
			if( data.results.length > 0 ){
				$('#searchFaqResult').append( '<hr>');
				data.results.forEach(function(val){
					$('#searchFaqResult').append( '<a href="#" class="h4 margin-top-20">' + val.title + '</a><div class="hidden searchFaqResultItem">' + val.body + '</div><hr>' )
				});
				$('#searchFaqResult').append('<button class="a-button btn btn-default btn-xs" id="feedbackCloseResult">Sulje hakutulokset</button>');
			}
			else {
				$('#searchFaqResult').html('<div class="h4 margin-top-20">Ei hakutuloksia</div>')
			}
		}

	}
	/* EOF: feedback pages */


	function vmCompo() {
		var $compo = $('.vm-compo');
		if (!$compo.length) return;

		var $form = $compo.find('.join-compo-form');

		$form.submit(function(e) {
			e.preventDefault();
			$compo.addClass('loading');
			return $.post('/stage-ajax/joinWeeklyCompo', $form.serialize())
				.then(function(res) {
					if (res) {
						$compo.find('#section1, #section2').hide();
						if (res.result && res.result === 1) {
							$compo.find('section.thankyou').show();
						} else if (res.already_joined) {
							$compo.find('section.already-joined').show();
						}
					}
				})
				.always(function() {
					$compo.removeClass('loading');
				});
		});
	}

	$(document).ready(function(){

		if($('.lottery-rules-link').length > 0) {
		  $('.lottery-rules-link').huuLightBox({'type': 'dom','source': '.lottery-rules-holder'});
		}

		if ($('body').hasClass('feedback')){
			feedbackPage();
		}
		vmCompo();

		allPages();

	});


}
